import { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import ProductCategories from "../components/ProductCategories";
import FeaturedProducts from "../components/FeaturedProducts";
import WhyChoose from "../components/WhyChoose";
import Industries from "../components/Industries";
import Stats from "../components/Stats";
import Testimonials from "../components/Testimonials";
import GoogleReviews from "../components/GoogleReviews";
import BrandPartners from "../components/BrandPartners";
import Gallery from "../components/Gallery";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingActions from "../components/FloatingActions";
import EnquiryDialog from "../components/EnquiryDialog";
import { SEO_KEYWORDS } from "../data/content";
const Home = () => {
    const [enq, setEnq] = useState({ open: false, product: "" });

    return (
        <main data-testid="home-page">
            <Header />
            <Hero />
            <BrandPartners />
            <About />
            <Services />
            <ProductCategories />
            <Stats />
            <FeaturedProducts onEnquiry={(name) => setEnq({ open: true, product: name })} />
            <WhyChoose />
            <Industries />
            <Testimonials />
            <GoogleReviews />
            <Gallery />
            <FAQ />
            <Contact />
            <Footer />
            <FloatingActions />
            <EnquiryDialog
                open={enq.open}
                onOpenChange={(o) => setEnq((p) => ({ ...p, open: o }))}
                productName={enq.product}
                
            />
             <section className="sr-only" aria-hidden="true">
                <h1>Medical Equipment Supplier India - Ezhil Biomedical</h1>
                <p>{SEO_KEYWORDS.hiddenParagraph}</p>
                <p>{SEO_KEYWORDS.globalLocations}</p>
            </section>

            <FloatingActions />
            <EnquiryDialog
                open={enq.open}
                onOpenChange={(o) => setEnq((p) => ({ ...p, open: o }))}
                productName={enq.product}
            />
        </main>
    );
};

export default Home;
